export const BUILD_VERSION = '1784311482';
